import { concat, defaults, get, isArray, isNumber } from 'lodash';
import { RootAction } from 'types'; // eslint-disable-line

import { EntityBase, EntityID } from '../resources/types';

const initialState: any = {};

/**
 * Data coming from API responses
 */
export interface DataPaginated<E extends EntityBase> {
  page: number;
  size: number;
  totalSize?: number;
  response: E[];
}

/**
 * Paginated results normalized inside the Redux Store
 */
export interface ResultPaginated {
  page: number;
  size: number;
  loading: boolean;
  hasMore: boolean;
  totalSize: number;
  response: EntityID[];
  responseAgregated: EntityID[];
}

export type Result = EntityID | EntityID[] | ResultPaginated;

export type ResultStore = { [key: string]: Result };

export default function createResultReducer() {
  return (state = initialState, action: RootAction) => {
    const resultKey = get(action, 'payload.meta.resultKey');
    if (resultKey) {
      const result = get(action, 'payload.normalized.result') || {};
      const config = get(action, 'payload.config');
      const loading = !get(action, 'payload.status');
      const page = result.page || get(config, 'params.page');
      let data = {
        ...(isArray(result) ? { response: result } : result),
        page,
        config,
        loading,
      };

      // handle result paginated
      if (!loading && isNumber(page)) {
        const prevPage = get(state, `${resultKey}.page`, 1);
        const prevResponseAgregated = [...get(state, `${resultKey}.responseAgregated`, [])];

        // handle response agregated for infinite scroll
        let responseAgregated;
        if (page === prevPage + 1) {
          responseAgregated = concat(prevResponseAgregated, data.response);
        } else if (page > 1 && page === prevPage) {
          responseAgregated = prevResponseAgregated;
        } else {
          responseAgregated = data.response;
        }
        data = {
          ...data,
          responseAgregated,
          hasMore: !loading && (result.totalSize > responseAgregated.length || !result.totalSize),
        };
      }
      return {
        ...state,
        [resultKey]: defaults(data, state[resultKey]),
      };
    }
    return state;
  };
}
